import Image from "next/image"
import styles from "./person.module.css"
import { Person as Icon } from "@/common/icons/person"
import classNames from "classnames"

export default function Person({ person, toggleModal }) {
  if (!person) {
    return null
  }

  const emailHash = person.email
    ? Buffer.from(person.email, "binary").toString("base64")
    : null
  const hasDesc = String(person?.desc).length > 0

  function showEmail(hash) {
    window.location.href =
      "mailto:" + Buffer.from(hash, "base64").toString("ascii")
  }

  return (
    <li className={styles.card}>
      <div
        className={classNames(["image-wrapper", { "has-detail": hasDesc }])}
        onClick={() => hasDesc && toggleModal(true, person)}>
        <Avatar avatar={person.avatar} />
      </div>
      <div className="text-wrapper">
        <h3>{person.name}</h3>
        <span>{person.position}</span>
        <button aria-label="Mejla mig" onClick={() => showEmail(emailHash)}>
          Mejla mig
        </button>
        <Phone person={person} />
        {hasDesc && (
          <button
            aria-label="Läs mer om mig"
            onClick={() => toggleModal(true, person)}>
            Läs mer om mig
          </button>
        )}
      </div>
    </li>
  )
}

const Phone = ({ person }) => {
  const links = []

  if (person.phone) {
    links.push(
      <a
        key={person.phone}
        className="inline-block underline"
        href={`tel:${person.phone}`}>
        {person.phone}
      </a>
    )
  }

  if (person.phone && person.altPhone) {
    links.push(" / ")
  }

  if (person.altPhone) {
    links.push(
      <a
        key="alt-phone"
        className="inline-block underline"
        href={`tel:${person.altPhone}`}>
        {person.altPhone}
      </a>
    )
  }

  return links
}

const Avatar = ({ avatar }) => {
  if (!avatar) {
    return (
      <div className="icon">
        <Icon />
      </div>
    )
  }

  return (
    <Image
      className="object-cover object-center w-full h-full"
      src={avatar.url}
      sizes="(max-width: 768px) 360px"
      width={avatar.width}
      height={avatar.height}
      alt={avatar.alt}
    />
  )
}
